import React from "react";

// Today's Result on Home — compact SUNDAY TEER table style.
export default function ResultCard({ result }) {
  const { date, city, frTime, srTime, fr, sr, notDeclared } = result;
  return (
    <div className="mx-auto w-full" style={{ maxWidth: "620px" }}>
      <div className="text-center font-black text-xl sm:text-2xl mb-1 text-[#111]">{date}</div>
      <div className="border-2 border-gray-400 overflow-hidden bg-white">
        {/* City */}
        <div className="text-center font-bold text-lg py-1.5 bg-[#eaeaea] border-b-2 border-gray-400 text-[#111]">
          {(city || "SUNDAY TEER").toUpperCase()}
        </div>
        {/* Round headers */}
        <div className="grid grid-cols-2 border-b-2 border-gray-400">
          <div className="text-center font-bold text-base sm:text-lg py-1.5 bg-[#3bd4bd] border-r-2 border-gray-400 text-[#111]">
            F/R({frTime})
          </div>
          <div className="text-center font-bold text-base sm:text-lg py-1.5 bg-[#3bd4bd] text-[#111]">
            S/R({srTime})
          </div>
        </div>
        {/* Numbers OR Not Declared */}
        {notDeclared ? (
          <div className="text-center font-black text-lg sm:text-xl py-4 text-[#c53a12]">
            Result Not Declared Yet
          </div>
        ) : (
          <div className="grid grid-cols-2">
            <div className="text-center font-black text-2xl sm:text-3xl py-2 border-r-2 border-gray-400 text-[#111]">
              {fr}
            </div>
            <div className="text-center font-black text-2xl sm:text-3xl py-2 text-[#111]">
              {sr}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
